import { ErrorMessage, Field, Form, Formik } from "formik";
import { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import Select from "react-select";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import * as Yup from "yup";
import {
  ErrorUnexpected,
  OperationSuccessfully,
} from "../../../../../../../const/Messages";
import * as PlmnService from "../../../../../../../service/PlmnService";
import * as TemplateService from "../../../../../../../service/TemplateEricssonHlrService";
import Loading from "../../../../../../Common/Loading/Loading";

const initialValues = {
  gt: "",
  roamrest: true,
  plmn: {
    id: "",
  },
  description: "",
};

/**
  @author Guilherme Almeida
  @date 08/03/2021
 */
export default function TemplateEricssonHLRRegister({ location }) {
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [tadigs, setTadigs] = useState([]);
  const [values, setValues] = useState(initialValues);

  useEffect(() => {
    PlmnService.findComboBox()
      .then((comboList) => {
        const comboOptions = comboList.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        setTadigs(comboOptions);
      })
      .catch(() => toast.error(ErrorUnexpected));

    if (location && location.state && location.state.id) {
      TemplateService.getById(location.state.id)
        .then((template) => {
          setValues({
            gt: template.gt !== undefined && template.gt !== null ? String(template.gt) : "",
            roamrest: template.roamrest !== undefined && template.roamrest !== null ? Boolean(template.roamrest) : true,
            plmn: template.plmn ? { id: template.plmn.id, name: template.plmn.name } : { id: "" },
            description: template.description || "",
          });
          setLoading(false);
        })
        .catch(() => {
          history.push("/settings/report/template/hlr/ericsson/template", {
            message: ErrorUnexpected,
            messageType: "error",
          });
        });
    } else {
      setLoading(false);
    }
  }, []); // eslint-disable-line

  const schema = Yup.object().shape({
    gt: Yup.string()
      .matches(/^[0-9]+$/, "Global Title must contain only digits")
      .required("Global Title is a required field"),
    plmn: Yup.object().shape({
      id: Yup.number()
        .typeError("TADIG is a required field")
        .required("TADIG is a required field"),
    }),
    description: Yup.string().nullable(),
  });

  function handleSave(formValues, actions) {
    let id = null;
    if (location && location.state && location.state.id) {
      id = location.state.id;
    }

    const payload = {
      gt: String(formValues.gt).trim(),
      roamrest: Boolean(formValues.roamrest),
      plmn: {
        id: Number(formValues.plmn.id),
      },
      description: formValues.description || "",
    };

    TemplateService.merge(id, payload)
      .then(() => {
        history.push("/settings/report/template/hlr/ericsson/template", {
          message: OperationSuccessfully,
          messageType: "success",
        });
      })
      .catch((error) => {
        if (!error || !error.response || !error.response.data) {
          toast.error(ErrorUnexpected);
        } else if (error.response.data.fields) {
          error.response.data.fields.forEach((field) => {
            actions.setFieldError(field.name, field.message);
          });
        } else if (error.response.data.title) {
          actions.setFieldError("gt", error.response.data.title);
          toast.error(error.response.data.title);
        } else {
          toast.error(ErrorUnexpected);
        }
        actions.setSubmitting(false);
      });
  }

  function handleDelete(id) {
    Swal.fire({
      icon: "warning",
      title: "Confirmation",
      text: "Are you sure you want to delete?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      closeOnConfirm: true,
    }).then((result) => {
      if (result.isConfirmed) {
        TemplateService.deleteById(id).then(() => {
          history.push("/settings/report/template/hlr/ericsson/template", {
            message: OperationSuccessfully,
            messageType: "success",
          });
        });
      }
    });
  }

  if (loading) {
    return <Loading />;
  }

  return (
    <Row>
      <Col>
        <div className="ibox">
          <div className="ibox-title">
            <h5>
              {location && location.state && location.state.id
                ? "Template Ericsson HLR - Edit"
                : "Template Ericsson HLR - Register"}
            </h5>
          </div>
          <div className="ibox-content">
            <Formik
              initialValues={values}
              enableReinitialize
              validationSchema={schema}
              onSubmit={handleSave}
            >
              {({ values, setFieldValue }) => (
                <Form>
                  <div className="form-group row">
                    <label
                      htmlFor="gt"
                      className="col-form-label col-sm-12 col-md-4 col-lg-4 col-xl-3 col-xxl-1"
                    >
                      Global Title:
                    </label>
                    <div className="col-sm-12 col-md-8 col-lg-6 col-xl-4">
                      <Field
                        className="form-control"
                        name="gt"
                        type="text"
                        placeholder="Global Title (e.g. 551199999)"
                      />
                      <span className="text-danger">
                        <ErrorMessage name="gt" />
                      </span>
                    </div>
                  </div>

                  <div className="form-group row">
                    <label
                      htmlFor="plmn"
                      className="col-form-label col-sm-12 col-md-4 col-lg-4 col-xl-3 col-xxl-1"
                    >
                      TADIG:
                    </label>
                    <div className="col-sm-12 col-md-8 col-lg-6 col-xl-4">
                      <Select
                        className="flex-1"
                        styles={{
                          placeholder: (defaultStyle) => ({
                            ...defaultStyle,
                            color: "#495057",
                          }),
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 9999,
                          }),
                        }}
                        placeholder="-- Select TADIG --"
                        options={tadigs}
                        name="plmn.id"
                        value={
                          tadigs.find(
                            (tadig) =>
                              tadig.value ===
                              (values.plmn && values.plmn.id)
                          ) || null
                        }
                        onChange={(item) => {
                          setFieldValue("plmn.id", item ? item.value : "");
                        }}
                        isClearable
                      />
                      <span className="text-danger">
                        <ErrorMessage name="plmn.id" />
                      </span>
                    </div>
                  </div>

                  <div className="form-group row">
                    <label
                      htmlFor="roamrest"
                      className="col-form-label col-sm-12 col-md-4 col-lg-4 col-xl-3 col-xxl-1"
                    >
                      ROAMREST:
                    </label>
                    <div className="col-sm-12 col-md-8 col-lg-6 col-xl-4 d-flex align-items-center">
                      <div className="custom-control custom-switch">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          id="roamrest"
                          name="roamrest"
                          checked={Boolean(values.roamrest)}
                          onChange={(e) =>
                            setFieldValue("roamrest", e.target.checked)
                          }
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="roamrest"
                          style={{ cursor: "pointer" }}
                        >
                          {values.roamrest ? "Active" : "Inactive / Blocked"}
                        </label>
                      </div>
                      <span className="text-danger">
                        <ErrorMessage name="roamrest" />
                      </span>
                    </div>
                  </div>

                  <div className="form-group row">
                    <label
                      htmlFor="description"
                      className="col-form-label col-sm-12 col-md-4 col-lg-4 col-xl-3 col-xxl-1"
                    >
                      Description:
                    </label>
                    <div className="col-sm-12 col-md-8 col-lg-6 col-xl-4">
                      <Field
                        as="textarea"
                        rows={3}
                        className="form-control"
                        name="description"
                        placeholder="Description or reason"
                      />
                      <span className="text-danger">
                        <ErrorMessage name="description" />
                      </span>
                    </div>
                  </div>

                  <div className="d-flex justify-content-end">
                    <Link
                      className="mr-1 btn btn-primary"
                      to="/settings/report/template/hlr/ericsson/template"
                    >
                      Cancel
                    </Link>
                    {location && location.state && location.state.id && (
                      <Button
                        className="mr-1"
                        onClick={() => handleDelete(location.state.id)}
                        variant="primary"
                        type="button"
                      >
                        Delete
                      </Button>
                    )}
                    <Button variant="primary" type="submit">
                      {location && location.state && location.state.id
                        ? "Update"
                        : "Save"}
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </Col>
    </Row>
  );
}
